import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useSpring, animated as a } from 'react-spring';
import loginStyles from './login.module.css';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import { Alert } from '@mui/material';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const fadeIn = useSpring({
    from: { opacity: 0, transform: 'translateY(30px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 120, friction: 20 }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    setTimeout(() => {
      const result = login(email, password);
      if (result.success) {
        navigate('/');
      } else {
        setError(result.error);
      }
      setIsLoading(false);
    }, 500);
  };

  const handleTestAccount = () => {
    setEmail('test@podcast.com');
    setPassword('test123');
  };

  return (
    <div className={loginStyles.main}>
      <a.div style={fadeIn} className={loginStyles.container}>
        <div className={loginStyles.logo}>
          <HeadphonesIcon sx={{ fontSize: 60, color: '#000' }} />
        </div>
        <h2 className={loginStyles.h2}>Welcome Back</h2>
        <p className={loginStyles.p}>Log in to continue listening</p>

        {error && (
          <Alert severity="error" sx={{ marginBottom: 2, width: '100%' }}>
            {error}
          </Alert>
        )}

        <form className={loginStyles.form} onSubmit={handleSubmit}>
          <div className={loginStyles.inputGroup}>
            <EmailIcon className={loginStyles.icon} />
            <input
              className={loginStyles.input}
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className={loginStyles.inputGroup}>
            <LockIcon className={loginStyles.icon} />
            <input
              className={loginStyles.input}
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className={loginStyles.loginBtn}
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>

          <div className={loginStyles.divider}>
            <span>OR</span>
          </div>

          <button
            type="button"
            className={loginStyles.testBtn}
            onClick={handleTestAccount}
          >
            Use Test Account
          </button>

          <div className={loginStyles.links}>
            <a href="/signup" className={loginStyles.link}>
              Don't have an account? Sign up
            </a>
          </div>
        </form>

        <div className={loginStyles.testCredentials}>
          <p>Test Account Credentials:</p>
          <span>test@podcast.com / test123</span>
        </div>
      </a.div>
    </div>
  );
}

export default Login;